module.exports = __webpack_public_path__ + "img/AI.bec74090.png";